export default __webpack_public_path__ + "static/media/notification-23-24.886531fc.pdf";